export enum EAirSearchFields {
    fullServiceCarriersOnly = 'fullServiceCarriersOnly',
    host = 'host',
    segment = 'segment',
    fareType = 'fareType',
    begin = 'begin',
    end = 'end',
    between = 'between',
    min = 'min',
    max = 'max',
    xMoment = 'xMoment',
    cabin = 'cabin',
    maxVias = 'maxVias',
    duration = 'duration',
    unit = 'unit',
    value = 'value',
    time = 'time',
    from = 'from',
    isFromAirport = 'isFromAirport',
    to = 'to',
    isToAirport = 'isToAirport',
    nextDay = 'NextDay',
    plusOrMinus = 'plusOrMinus',
    flexibility = 'flexibility',
    keyword = 'keyword',
    adult = 'adult',
    child = 'child',
    infant = 'infant',
    include = 'include',
    exclude = 'exclude',
    preferred = 'preferred',
    carrier = 'carrier',
    locator = 'locator',
    quantity = 'quantity',
    price = 'price',
    percentage = 'percentage'
}